// 中文
const zh = {
    // 首页-激活说明
    activateExplain: {
        title: '激活您的延长保修并获取给您的特别礼物',
        desp: '适用条件：为符合条件，客户同意与购买的我们的产品共享购物经验，这些产品已经使用了至少一周。',
        conditions: [
            '仅针对在Amazon上购买产品的客户',
            '每个客户只能为一种产品索取一份免费礼品。（这意味着无论您购买相同产品多少次，您都只能获得一份免费礼物）。',
        ]
    },
    // 首页-激活表单
    activateForm: {
        title: '激活您的扩展保修并立即获得免费礼物！',
        desp: '仅适用于现有客户',
        name: '姓名',
        namePlaceholder: `输入收件人姓名`,
        nameErrMsg: `姓名不正确。`,
        email: '电子邮件',
        emailPlaceholder: `输入您的电子邮件`,
        emailErrMsg: `电子邮件不正确。`,
        verifCode: '验证码',
        verifCodePlaceholder: `输入您的验证码`,
        verifCodeErrMsg: `验证码不正确。`,
        btnSendCode: `发送验证码`,
        countdownMsg: `{countdown}秒后重新发送`,
        orderId: '订单编号',
        orderIdPlaceholder: `输入您的订单编号`,
        orderIdErrMsg: `订单编号不正确。`,
        orderAppliedError: `该订单已领取过礼物。`,
        skuAppliedError: `该订单的礼物已被领取。`,
        orderIdHelp: '如何找到您的订单编号？',
        btnAactivate: '立即激活',
        statement: '我们当然不会与他人分享您的个人信息。',
        orderIdErrPopoverMsg: '如果您的订单ID正确无误，请通过电子邮件与我们的客户服务联系。 我们将帮助您激活扩展保修，并确认该事件是否涵盖您的市场。',
        priceErrPopoverMsg: '很抱歉告诉您，此订单使用了我们的最低折扣，如有任何问题，欢迎给我们发送电子邮件。'
    },
    // 通用弹框
    commonModal: {
        msg: `{msg}`,
        msgContents: [
            `收件人姓名与订单不符`,
            `亚马逊的评论是否完成？`,
            `您想继续前往Amazon进行评论吗？`
        ],
        btnRewrite: '重写',
        btnNo: '没有',
        btnYes: '是的'
    },
    // 选择礼物
    chooseGift: {
        title: '现在，选择您想要的礼物。',
        modalTitle: '抱歉，您选择的礼物不再可用，请再次选择',
        btnWant: '我要它',
        btnStockout: '缺货'
    },
    // 订单信息
    orderInfo: {
        title: '恭喜你！ 您的延长保修已激活！',
        desp: '你会得到什么',
        orderTitle: '您的订单信息',
        orderId: '订单编号',
        productASIN: '产品 ASIN',
        productName: '产品名称',
        address: '地址',
        aboutGift: [
            '关于礼物',
            '没有运输费，没有任何隐藏费用，不需要信用卡。',
            '只需4个简单步骤即可完成操作（少于5分钟）。',
            '礼物将在您领取后的2-5个工作日内发送给您。'
        ],
        btnWant: '我要它'
    },
    // 步骤1
    stepOne: {
        title: '第1步，共4步：关于购买的简短调查。',
        questionList: [{
                id: 1,
                select_type: 'radio',
                name: 'sex',
                title: '1. 我是……？',
                option: [{
                        txt: '女',
                        value: 0
                    },
                    {
                        txt: '男',
                        value: 1
                    },
                    {
                        txt: '不确定',
                        value: 2
                    }
                ]
            },
            {
                id: 2,
                select_type: 'radio',
                name: 'age',
                title: `2. 您的年龄范围是多少？`,
                option: [{
                        txt: '小于20',
                        value: 0
                    },
                    {
                        txt: '20-30',
                        value: 1
                    },
                    {
                        txt: '30-40',
                        value: 2
                    },
                    {
                        txt: '40-50',
                        value: 3
                    },
                    {
                        txt: '50-60',
                        value: 4
                    },
                    {
                        txt: '超过60',
                        value: 5
                    }
                ]
            },
            {
                id: 3,
                select_type: 'radio',
                name: 'reason',
                title: '3. 您为什么选择我们？',
                option: [{
                        txt: '品牌',
                        value: 0
                    },
                    {
                        txt: '设计',
                        value: 1
                    },
                    {
                        txt: '价钱',
                        value: 2
                    },
                    {
                        txt: '特征',
                        value: 3
                    },
                    {
                        txt: '评论',
                        value: 4
                    },
                    {
                        txt: '其他原因',
                        value: 5,
                        placeholder: '请输入原因'
                    }
                ]
            },
        ],
        btnNext: '下一步'
    },
    // 步骤2
    stepTwo: {
        title: '第2步，共4步：告诉我们您对产品的体验。',
        despOne: `总体评价？`,
        despTwo: `让我们知道我们的产品如何为您服务。`,
        notice: `（请输入至少10个字符）`,
        commentPlaceholder: '输入您的评论',
        commentErrMsg: `评论字数不能超过20000`,
        btnNext: '下一步',
        btnPrev: '上一步'
    },
    // 步骤3
    stepThree: {
        title: '第3步，共4步：与他人分享您的购物经验。',
        desp: '只需花费您几秒钟。 您的评论将帮助其他客户做出更好的购物决定。 感谢您的理解和支持。',
        commentTitle: '你的评论',
        defaultComment: '我非常喜欢您的产品！',
        btnCopyPost: '单击此处复制并发布您的amazom评论'
    },
    // 步骤4
    stepFour: {
        title: '第4步，共4步：确认您的地址。',
        desp: '你会得到什么',
        fullName: '全名',
        fullNamePlaceholder: `输入您的全名`,
        fullNameErrMsg: `全名不正确`,
        phone: '电话',
        phonePlaceholder: `输入您的电话`,
        phoneErrMsg: `电话不正确`,
        email: '电子邮件',
        emailPlaceholder: `输入您的电子邮件`,
        emailErrMsg: `电子邮件不正确`,
        address: '地址',
        addressPlaceholder: `输入您的地址`,
        addressErrMsg: `地址不正确`,
        streetPlaceholder:`街道地址`,
        apartmentPlaceholder:`小区/单元`,
        cityPlaceholder:`城市`,
        regionPlaceholder: `选择省份`,
        countryPlaceholder: `选择国家`,
        postcode: '邮政编码',
        postcodePlaceholder: `输入您的邮政编码`,
        postcodeErrMsg: `邮政编码不正确`,
        btnComfirm: '确认'
    },
    // 完成礼物申请
    completeApplication: {
        title: `您已经完成了免费礼物申请`,
        msgs: [
            '免费礼物将在2-5个工作日内寄出。',
            '免费礼物将在2-5个工作日内发送到您的电子邮件 ',
            '。衷心感谢您购买我们的产品，然后会有专门的售后团队联系。',
            '您可能遇到的其他任何问题，请通过电子邮件与我们的客户服务联系或访问我们的官方网站。',
            '由于您对我们的产品不是100％满意，因此可以通过电子邮件与我们的客户服务联系或访问我们的官方网站，我们将为您提供专业服务。 100％的客户满意度是我们的保证！'
        ],
        btnComfirm: '确认'
    },
    // 获取订单号指导
    guide: {
        title: '如何找到您的订单编号？',
        desps: [
            `第1步：登录您的Amazon帐户，然后在“帐户和列表”页面中单击“您的订单”`,
            `第2步：在正确的订单上点击“订单详情”`,
            `第3步：您将看到您的订单编号`
        ],
        btnOK: '好的'
    }
}

export default zh